<template>
  <div class="container" v-if="loading">
    <div class="spinner"></div>
    <div class="message">{{InformationMessage}}</div>
  </div>
  <div v-else>
    <br/><br/>
    <div class="container">
      <h1>Your Account</h1>
      <div class="grid-x grid-margin-x">
      <div class="cell small-12">
        <table>
            <thead>
                <tr>
                <th>Account Details</th>
                <th></th>
                <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>                            
                    <td>Name</td>
                    <td>{{identity.account.name}}</td>
                    <td></td>
                </tr>
                <tr>                            
                    <td>Email</td>
                    <td>{{identity.account.idTokenClaims.email}}</td>
                    <td></td>
                </tr>
                <tr v-if="identity.idTokenClaims.userType == 'Intermediary'">    
                    <td>Linked Intermediary</td>
                    <td>{{identity.intermediary.name}} (<a href="/intermediary/manage">Manage</a>)</td>    
                    <td></td>                   
                </tr>
                <tr>                            

                </tr>

            </tbody>
            </table>
            <button class="btn btn-primary" @click="identity.logout()">Logout</button>
      </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, reactive } from 'vue';

import { useIdentityStore } from '@/stores/identity';

const identity = useIdentityStore();

var loading = ref(false);
var InformationMessage = ref('Loading your account...');



onMounted(async () => {
  InformationMessage.value = InformationMessage.value;
});



</script>
